export const getUTMSearchParamString = () => {
  const windowSearchParams = new URLSearchParams(window.location.search);
  const utmsConfig = {
    utm_source: windowSearchParams.get("utm_source"),
    utm_medium: windowSearchParams.get("utm_medium"),
    utm_campaign: windowSearchParams.get("utm_campaign"),
    utm_term: windowSearchParams.get("utm_term"),
    utm_content: windowSearchParams.get("utm_content"),
  };

  const utms = new URLSearchParams(
    Object.entries(utmsConfig).filter(([_key, val]) => !!val) as [
      string,
      string,
    ][],
  );
  return utms.toString();
};
